/**
 * @generated SignedSource<<de84f74a5d5bb70960a9f764e17c235f>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type InvitePanel_Booking$data = {
  readonly " $fragmentSpreads": FragmentRefs<"InviteCardActionButton_Booking" | "InviteCardBookingInfoSection_Booking" | "InviteCardTopSection_Booking" | "useHandleUserAlreadyInBooking_Booking">;
  readonly " $fragmentType": "InvitePanel_Booking";
};
export type InvitePanel_Booking$key = {
  readonly " $data"?: InvitePanel_Booking$data;
  readonly " $fragmentSpreads": FragmentRefs<"InvitePanel_Booking">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "InvitePanel_Booking",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "InviteCardTopSection_Booking"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "InviteCardBookingInfoSection_Booking"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "InviteCardActionButton_Booking"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "useHandleUserAlreadyInBooking_Booking"
    }
  ],
  "type": "Booking",
  "abstractKey": "__isBooking"
};

(node as any).hash = "329eacfce0d586f18b17a3a56260b9ef";

export default node;
